module.exports = __webpack_public_path__ + "static/media/upload_white.cf6a61dc.svg";